//----- Component --------------------------------------------------------/
// Developer     : Guillermo Sedran
// Creation Date : 07/10/2025
// Version       : 1
// Description   : Tabla de tipos de vehiculos
//
//------Changes --------------------------------------------------------------------- -------------//
// Change Date   :
// Change by     :
// Change description:
//
// Change Date   :
// Change by     :
// Change description:
//
//========================================================================/

import { useState, useEffect, useMemo } from "react";
import { UrlApi } from "../../../../services/apirest";
import Navbar from "../../../Navbar";
import { MaterialReactTable } from "material-react-table";
// TABLA EN ESPAÑOL
import { MRT_Localization_ES } from "material-react-table/locales/es";
import {
  Box,
  Dialog,
  Typography,
  IconButton,
  Button,
  ThemeProvider,
  createTheme,
  useTheme,
  Tooltip,
} from "@mui/material";

import AgregarTipo from "./AgregarTipo";
import EditarTipo from "./EditarTipo";
import CambiarEstadoTipo from "./CambiarEstadoTipo";
import RelacionTipoVehiculoComponentes from "./relacion_tipo_v_componentes/RelacionTipoVehiculoComponentes";

// ICONOS
import AddBoxOutlinedIcon from "@mui/icons-material/AddBoxOutlined";
import BlockIcon from "@mui/icons-material/Block";
import EditIcon from "@mui/icons-material/Edit";

function TipoVehiculos() {
  const globalTheme = useTheme();

  const [tipos, setTipos] = useState([]);
  const [tipoSeleccionado, setTipoSeleccionado] = useState([]);

  //*************************************************************************************************************************************/

  const obtenerTipos = () => {
    // fetch(UrlApi + "/tipos_vehiculos")
    fetch(UrlApi + "/tipos_vehiculos2")
      .then((data) => data.json())
      .then((data) => setTipos(data));
  };

  useEffect(() => {
    obtenerTipos();
  }, []);

  //*************************************************************************************************************************************/

  // DIALOG PARA AGREGAR PRODUCTO
  const [dialogAgregar, setDialogAgregar] = useState(false);

  // Abrir diálogo para agregar producto
  const handleOpenAgregarTipo = () => {
    setDialogAgregar(true);
  };

  // Cerrar diálogo
  const handleCloseAgregarTipo = () => {
    setDialogAgregar(false);
  };

  //*************************************************************************************************************************************/

  // DIALOG PARA AGREGAR PRODUCTO
  const [dialogEditar, setDialogEditar] = useState(false);

  // Abrir diálogo para agregar producto
  const handleOpenEditarTipo = (row) => {
    setTipoSeleccionado(row);
    setDialogEditar(true);
  };

  // Cerrar diálogo
  const handleCloseEditarTipo = () => {
    setDialogEditar(false);
  };

  //*************************************************************************************************************************************/

  // DIALOG PARA CAMBIAR ESTADO DE LAS PRODUCTOS
  const [openCambiarEstadoTipo, setOpenCambiarEstadoTipo] = useState(false);

  const handleOpenCambiarEstadoTipo = (row) => {
    setTipoSeleccionado(row);
    setOpenCambiarEstadoTipo(true);
  };

  const handleCloseCambiarEstadoTipo = () => {
    setOpenCambiarEstadoTipo(false);
  };

  console.log("Tipo seleccionado: ", tipoSeleccionado)

  //*************************************************************************************************************************************/

  // ----------- TABLA ---------------
  const customLocalization = {
    ...MRT_Localization_ES,
    body: {
      ...MRT_Localization_ES.body,
      noData: "No hay registros para mostrar",
    },
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: "id",
        header: "ID",
        size: 100,
      },
      {
        accessorKey: "nombre",
        header: "Nombre",
        size: 150,
      },
    ],
    []
  );

  const initialState = {
    density: "compact",
    showGlobalFilter: true,
    pagination: { pageIndex: 0, pageSize: 10 },
  };

  const tableHeadCellProps = {
    align: "left",
    sx: {
      fontSize: 16,
      color: "white",
      fontWeight: "normal",
      backgroundColor: "#2471A3",
      borderColor: "black",
      "& .MuiSvgIcon-root": {
        color: "white", // color de los íconos
      },
    },
  };

  const muiSearchTextFieldProps = {
    placeholder: "Buscar..",
    sx: { backgroundColor: "#ffffff" },
    variant: "outlined",
    size: "small",
  };

  const tableTheme = useMemo(
    () =>
      createTheme({
        palette: {
          mode: globalTheme.palette.mode,
          primary: globalTheme.palette.primary,
          info: {
            main: "rgb(255,122,0)",
          },
          background: {
            default: "rgb(234, 239, 241)",
          },
        },
        typography: {
          button: {
            textTransform: "none",
            fontSize: "1rem",
          },
        },
        components: {
          MuiTooltip: {
            styleOverrides: {
              tooltip: {
                fontSize: "0.8rem",
              },
            },
          },
        },
      }),
    [globalTheme]
  );

  //*************************************************************************************************************************************/

  // Función para actualizar los datos luego de que se guarde uno nuevo
  const handleTipoGuardado = () => {
    obtenerTipos(); // Vuelve a obtener los datos actualizados
  };

  return (
    <>
      <Navbar />
      <Box
        sx={{
          marginTop: "20px",
          marginBottom: "25px",
          marginLeft: "40px",
          marginRight: "40px",
        }}
      >
        <ThemeProvider theme={tableTheme}>
          <MaterialReactTable
            columns={columns}
            data={tipos}
            initialState={initialState}
            positionActionsColumn="last"
            autoResetPageIndex={false}
            enableDensityToggle={false}
            enableFullScreenToggle={false}
            enableColumnActions={true}
            enableColumnFilters={false} // Desactiva filtros por columna
            enableHiding={false}
            localization={customLocalization}
            enableRowSelection={false}
            enableRowActions={true}
            enableGlobalFilter
            muiTableHeadCellProps={tableHeadCellProps}
            muiSearchTextFieldProps={muiSearchTextFieldProps}
            muiTableBodyCellProps={({}) => ({
              align: "left",
              sx: {
                color: "black",
                borderColor: "transparent",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              },
            })}
            muiTableBodyRowProps={({ table, row }) => {
              // índice real de la fila en el modelo (para alternancia)
              const rowIndex = table
                .getRowModel()
                .rows.findIndex((r) => r.id === row.id);

              // Paleta para los dos estados
              const palettes = {
                1: {
                  // ACTIVO (verdes)
                  active: ["#eafef0", "#d8fbe2"], // alternancia par/impar
                  hover: "#d1f7d6",
                },
                2: {
                  // INACTIVO (rojizos)
                  active: ["#fdeaea", "#fbdada"], // alternancia par/impar
                  hover: "#f8cfcf",
                },
                default: {
                  // fallback (por si el estado no es 1 ni 2)
                  active: ["#ffffff", "#fafafa"],
                  hover: "#f3f4f6",
                },
              };

              // Paleta según el estado (si no está 1 o 2, usa default)
              const estado = Number.parseInt(row.original?.estado, 10);
              const pal = palettes[estado] || palettes.default;

              // color de fondo alternado por index
              const bgColor = pal.active[rowIndex % 2];

              return {
                hover: false, // desactivamos hover por defecto de la tabla
                sx: {
                  backgroundColor: bgColor,
                  color: "black",
                  borderColor: "transparent",
                  transition:
                    "background-color 0.18s ease-in-out, transform 0.15s ease",
                  // línea inferior entre celdas
                  "& .MuiTableCell-root": {
                    borderBottom: "1px solid rgba(0,0,0,0.06)",
                  },
                  // hover personalizado
                  "&:hover": {
                    backgroundColor: pal.hover,
                    transform: "translateY(-1px)",
                  },
                },
              };
            }}
            renderTopToolbarCustomActions={() => (
              <>
                <Typography variant="poster" fontSize={26}>
                  Tipos De Vehículos
                </Typography>
                <Button
                  variant="contained"
                  size="small"
                  style={{ marginTop: "5px" }}
                  startIcon={<AddBoxOutlinedIcon />}
                  onClick={handleOpenAgregarTipo}
                >
                  Agregar Tipo
                </Button>
              </>
            )}
            renderRowActions={({ row }) => (
              <Box sx={{ display: "flex", flexWrap: "nowrap", gap: "8px" }}>
                <Tooltip
                  arrow
                  placement="left"
                  disableInteractive
                  title="Editar"
                >
                  <IconButton
                    onClick={() => handleOpenEditarTipo(row.original)}
                    disabled={row.original.estado === 2}
                  >
                    <EditIcon
                      sx={{
                        color:
                          row.original.estado === 2
                            ? "grey.500"
                            : "primary.main",
                      }}
                    />
                  </IconButton>
                </Tooltip>
                <Tooltip
                  arrow
                  placement="left"
                  disableInteractive
                  title={
                    row.original.estado === 1 ? "Anular Tipo" : "Activar Tipo"
                  }
                >
                  <IconButton
                    onClick={() => handleOpenCambiarEstadoTipo(row.original)}
                  >
                    <BlockIcon
                      sx={{
                        color: row.original.estado === 1 ? "red" : "green",
                      }}
                    />
                  </IconButton>
                </Tooltip>
              </Box>
            )}
            renderDetailPanel={({ row }) => (
              <>
                <RelacionTipoVehiculoComponentes row={row.original} />
              </>
            )}
          />
        </ThemeProvider>
      </Box>

      {/* AGREGAR COMPONENTE */}
      <Dialog
        fullWidth
        maxWidth={"md"}
        open={dialogAgregar}
        onClose={handleCloseAgregarTipo}
        PaperProps={{
          sx: {
            borderRadius: "16px",
            boxShadow: "0 25px 50px -12px rgba(0,0,0,0.25)",
            overflow: "hidden",
            border: "2px solid #2B76A6",
            backgroundColor: "#ffffff",
            boxSizing: "border-box",
          },
        }}
      >
        <AgregarTipo
          handleCloseAgregarTipo={handleCloseAgregarTipo} // Función para cerrar el diálogo
          onTipoGuardado={handleTipoGuardado} // Recargar tabla al guardar
        />
      </Dialog>

      {/* EDITAR COMPONENTE */}
      <Dialog
        fullWidth
        maxWidth={"md"}
        open={dialogEditar}
        onClose={handleCloseEditarTipo}
        PaperProps={{
          sx: {
            borderRadius: "16px",
            boxShadow: "0 25px 50px -12px rgba(0,0,0,0.25)",
            overflow: "hidden",
            border: "2px solid #2B76A6",
            backgroundColor: "#ffffff",
            boxSizing: "border-box",
          },
        }}
      >
        <EditarTipo
          tipo={tipoSeleccionado}
          handleCloseEditarTipo={handleCloseEditarTipo} // Función para cerrar el diálogo
          onTipoGuardado={handleTipoGuardado} // Recargar tabla al guardar
        />
      </Dialog>

      {/* CAMBIAR ESTADO TIPO */}
      <Dialog
        fullWidth
        maxWidth={"xs"}
        PaperProps={{
          sx: {
            borderRadius: "16px",
            boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
            overflow: "hidden",
          },
        }}
        open={openCambiarEstadoTipo}
        onClose={handleCloseCambiarEstadoTipo}
      >
        <CambiarEstadoTipo
          tipo={tipoSeleccionado}
          handleCloseCambiarEstadoTipo={handleCloseCambiarEstadoTipo} // Función para cerrar el diálogo
          onTipoGuardado={handleTipoGuardado} // Recargar tabla al guardar
        />
      </Dialog>
    </>
  );
}

export default TipoVehiculos;
